/* istanbul ignore file */
export * from './SelectedFilterValueChip';
